"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidForInRows = exports.getRowsWithFiles = void 0;
const webexUI_1 = require("webexUI");
const getRowsWithFiles = (rows) => {
    return rows.filter(row => row.downloadUrl && row.downloadUrl !== '\\' && row.downloadUrl !== '/');
};
exports.getRowsWithFiles = getRowsWithFiles;
const isValidForInRows = rows => {
    const result = rows.filter(row => {
        if (row.validForGlobal || (0, webexUI_1.safe)(row.validForList).length) {
            return row;
        }
    });
    return result.length > 0;
};
exports.isValidForInRows = isValidForInRows;
